export default __webpack_public_path__ + "static/media/cafeAhroma.b99a9f9c.png";